// Centralized background image configuration
// All images are stored locally in /public/img/ for reliability

export const IMAGES = {
  // ── Landing page ──────────────────────────────────────────────────────────
  PLATFORM_HERO_BG: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186811/CNC-Helpdesk_Landing_page_jdllbi.png',

  // ── CNC Router ────────────────────────────────────────────────────────────
  ROUTER_DASHBOARD:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186811/Router_Dashboard_jlqyqu.png',
  ROUTER_TROUBLESHOOTING:'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186815/Router_Troubleshooting_k86fmg.png',
  ROUTER_CALCULATOR:     'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186815/Router_Calculator_l2b1mi.png',
  ROUTER_KNOWLEDGE:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777192654/cnc_router_knowledgebase_2_ardbkb.png',

  // ── 3D Printing ───────────────────────────────────────────────────────────
  PRINTING3D_DASHBOARD:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186814/3dp_Dashboard_g9ztcc.png',
  PRINTING3D_TROUBLESHOOTING:'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186814/3dp_Troubleshooting_ypb1hf.png',
  PRINTING3D_MATERIALS:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186813/3dp_Materials_and_slicer_phol5m.png',
  PRINTING3D_KNOWLEDGE:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777193200/3dp_Knowledge_base_2_h8cfex.png',

  // ── Laser ─────────────────────────────────────────────────────────────────
  LASER_DASHBOARD: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186811/laser_Dashboard_hero_blfcic.png',
  LASER_MATERIALS: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186814/lasser_Materials_guide_p8llil.png',
  LASER_SAFETY:    'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186812/laser_Safety_section_ylxhyx.png',
  LASER_KNOWLEDGE: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186813/laser_Knowledge_Base_qree3n.png',

  // ── Laser (extended) ─────────────────────────────────────────────────────
  LASER_TROUBLESHOOTING:  'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217431/laser_troubleshooting_dwpyys.png',
  LASER_CALCULATOR:       'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217430/laser_calculator_jfouks.png',
  LASER_DESIGN_PREP:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217432/laser_design_prep_rzusyt.png',
  LASER_SOFTWARE:         'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217430/laser_software_guide_i6gypz.png',
  LASER_MACHINES_CATALOG: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217429/laser_machine_category_f7pm51.png',

  // ── CNC Router (extended) ────────────────────────────────────────────────
  ROUTER_CUTTING_TOOLS: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217429/router_cutting_tools_yscglc.png',

  // ── 3D Printing (extended) ───────────────────────────────────────────────
  PRINTING3D_SLICER:          'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217429/3dp_slicer_guide_w1bf2t.png',
  PRINTING3D_POST_PROCESSING: 'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217435/3dp_post_processing_doraw4.png',

  // ── Shared / Platform ────────────────────────────────────────────────────
  MY_EQUIPMENT:   'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217433/my_equipment_profile_ojfu3a.png',
  COMMUNITY_FORUM:'https://res.cloudinary.com/dleggnjxb/image/upload/v1777217434/community_forum_qmy7qk.png',

  // ── Legal ─────────────────────────────────────────────────────────────────
  COMMUNITY:    'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186811/cnc-helpdesk_Community_and_marketplace_egcbgn.png',
  TERMS_PRIVACY:'https://res.cloudinary.com/dleggnjxb/image/upload/v1777186811/cnc-helpdesk_t_Cs_sssvbb.png',

  // ── New shared Cloudinary keys ────────────────────────────────────────────
  AUTH_LOGIN:          'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263999/all_3_safety_first_jy5r93.png',
  MACHINE_SETUP_WIZARD:'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263340/Machine_setup_iaozcw.png',
  GETTING_STARTED:     'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263339/Getting_Started_mpfutu.png',
  METHODOLOGY:         'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263333/Methodology_k4ba9o.png',
  PROJECT_PICKER:      'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263334/Project_Picker_xb8ypt.png',
  MY_TOOLS:            'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263333/My_Tools_woirsw.png',
  MARKETPLACE:         'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263341/Market_Place_v0obq7.png',
  AI_ASSISTANT:        'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263338/AI_Assistant_tjyrgg.png',
  FEEDS_SPEEDS:        'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263337/cnc_router_calculator_b0lrsy.png',
  GCODE_CAM:           'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263336/GCode_Master_df5aal.png',
  CONTACT_FEEDBACK:    'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263335/Feedback_jll14t.png',
  SAFETY_DISCLAIMER:   'https://res.cloudinary.com/dleggnjxb/image/upload/v1777263999/all_3_safety_first_jy5r93.png',

  // ── Legacy local paths (still used by other pages — do not remove) ────────
  MAIN_BG:                '/img/cnc-main-bg.png',
  MACHINE_SETUP_BG:       '/img/machine-setup-bg.png',
  TROUBLESHOOTING_BG:     '/img/troubleshooting-bg.png',
  STEP_BY_STEP_BG:        '/img/step-by-step-guidance-bg.png',
  PRINT3D_MAIN_BG:        '/img/3dp-main-bg.png',
  PRINT3D_TROUBLESHOOTING_BG: '/img/3dp-troubleshooting-bg.png',
  PRINT3D_MACHINE_SETUP_BG:   '/img/3dp-machine-setup-bg.png',
  PRINT3D_CALCULATOR_BG:  '/img/3dp-calculator-bg.png',
  LASER_MAIN_BG:          '/img/laser-home-bg.png',
  LASER_MACHINE_SETUP_BG: '/img/laser-machine-setup-bg.png',
  LASER_CALCULATOR_BG:    '/img/laser-calculator-bg.png',
  LASER_TROUBLESHOOTING_BG:'/img/laser-troubleshooting-bg.png',

  // Logo
  LOGO: '/logo.png',
};

// Common background style object for reuse
export const bgStyle = (image) => ({
  backgroundImage: `url('${image}')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundAttachment: 'fixed',
});

export default IMAGES;
